import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { errorsInput } from 'src/consts';
import { addPlusOnPhone, isPhoneValid } from 'src/helpers';
import * as Yup from 'yup';
import { EditAgencyInputs } from '../components/EditAgencyInputs';
import { useAgencyAdapterAgencyDataModelToFormData } from './useAgencyAdapterAgencyDataModelToFormData';

type Props = {
  initialValues: EditAgencyInputs;
  isParent: boolean;
};

export const useEditAgencyForm = ({ initialValues, isParent }: Props) => {
  const { t } = useTranslation();

  const { agencyDataForm } = useAgencyAdapterAgencyDataModelToFormData(initialValues);

  const schema = Yup.object().shape({
    name: Yup.string().required(t('forms.required-field')),
    tel: isParent
      ? Yup.string().nullable()
      : Yup.string()
          .nullable()
          .required(t('forms.required-field'))
          .test('phone', t('forms.invalid-phone-format'), (value: string | null | undefined) => {
            if (!value) {
              return false;
            }

            const result = isPhoneValid(addPlusOnPhone(value));
            return result;
          }),
    // email shoud not be required if is partner
    email: isParent
      ? Yup.string().nullable()
      : Yup.string().nullable().required(t(errorsInput.required)).email(t(errorsInput.emailInvalidFormat)),
    address: Yup.string().nullable(),
    //currency: Yup.string().required(t(errorsInput.required)), since the currency not editable
    lat: Yup.number().nullable(),
    lang: Yup.number().nullable(),
    priceMini: isParent
      ? Yup.number().nullable()
      : Yup.number().nullable().required(t(errorsInput.required)).moreThan(0, t(errorsInput.moreThanZero)),
    pricePerKilo: isParent
      ? Yup.number().nullable()
      : Yup.number().nullable().required(t(errorsInput.required)).moreThan(0, t(errorsInput.moreThanZero)),
    city: Yup.string().nullable().required(t('forms.required-field')),
  });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isDirty, isSubmitted },
  } = useForm<EditAgencyInputs>({
    resolver: yupResolver(schema),
    // The next line I have to force to EUR because de SDTM agencies are not sending the currency but it's on morocco
    defaultValues: { ...agencyDataForm, currency: !agencyDataForm.currency ? 'EUR' : agencyDataForm.currency },
  });

  return {
    register,
    handleSubmit,
    errors,
    control,
    isDirty: isDirty && !isSubmitted,
  };
};
